import * as React from "react";
import { X, Settings, MessageSquare, Tags } from "lucide-react";
import ManageTagModal from "../../../Tag/components/ManageTagModal.jsx";
import ManageQuickMessageModal from "../../../QuickMessage/components/ManageQuickMessageModal.js/index.jsx";
import tagApi from "../../../../api/tagApi";

export default function SettingModal({
  isOpen,
  setIsOpen,
  user,
  shop,
  quickMessages,
  setQuickMessages,
  tags,
  setTags,
}) {
  const [activeTab, setActiveTab] = React.useState("quick_message");

  const menuItems = [
    { id: "quick_message", label: "Tin nhắn nhanh", icon: MessageSquare },
    { id: "tag_akabiz", label: "Tag akaBiz", icon: Tags },
  ];

  const refreshTags = async () => {
    try {
      const res = await tagApi.getByShopId(shop?._id);
      if (res.status === 1) setTags(res.data);
    } catch (error) {
      console.error("Error refreshing tags:", error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-16 text-black z-20">
      <div className="bg-white w-full h-[95vh] rounded-lg flex overflow-hidden relative">
        {/* Header */}
        <div className="absolute top-0 left-0 right-0 h-12 border-b flex items-center px-4 bg-white">
          <div className="flex items-center gap-2">
            <Settings className="w-4 h-4" />
            <span className="font-medium">Cài đặt cho zalo: {shop.name}</span>
          </div>
          <button
            onClick={() => setIsOpen(false)}
            className="absolute top-2 right-2 hover:bg-gray-100 p-2 rounded-full"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Sidebar */}
        <div className="w-48 border-r pt-12">
          <nav className="flex flex-col">
            {menuItems.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.id}
                  onClick={() => setActiveTab(item.id)}
                  className={`flex items-center gap-2 px-4 py-2 text-sm hover:bg-gray-100 ${
                    activeTab === item.id ? "bg-gray-100" : ""
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {item.label}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Content */}
        <div className="flex-1 pt-12 bg-contain">
          <div className="p-4 h-full">
            {activeTab === "quick_message" &&
              (user?.role?.includes("admin") ||
              user?.shopRoles
                ?.find((sr) => sr.shopId === shop._id)
                ?.permissions?.includes("manage_quick_message") ? (
                <ManageQuickMessageModal
                  shop={shop}
                  quickMessages={quickMessages}
                  setQuickMessages={setQuickMessages}
                  refreshTags={refreshTags}
                />
              ) : (
                "Không có quyền truy cập"
              ))}
            {activeTab === "tag_akabiz" &&
              (user?.role?.includes("admin") ||
              user?.shopRoles
                ?.find((sr) => sr.shopId === shop._id)
                ?.permissions?.includes("manage_tag") ? (
                <ManageTagModal shop={shop} tags={tags} setTags={setTags} />
              ) : (
                "Không có quyền truy cập"
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
